<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#token-s"></use></svg>
  Behandl brik
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>
@let idTagResult = idTag();

<mat-dialog-content class="dialog__content">
  <form [formGroup]="form">
    <ng-container>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Brik ID</mat-label>
          <input
            type="text"
            required=""
            placeholder="Brikkens ID..."
            matInput
            [matAutocomplete]="auto"
            formControlName="printedId"
            maxlength="6" />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectIdTag($event.option.value)" okCustomDropDownArrowDirective>
            @for (option of filteredLookupIdTags; track option) {
              <mat-option [value]="option.printedId">
                {{ option.printedId }}
              </mat-option>
            }
          </mat-autocomplete>
          <mat-hint align="end">{{ form.controls.printedId.value?.toString()?.length ?? 0 }}/6 cifre</mat-hint>
          <mat-error>
            @if (form.controls.printedId.errors && form.controls.printedId.errors['printedIdAlreadyUsed']) {
              Brik ID {{ form.controls.printedId.value }} er optaget
            }
            @if (form.controls.printedId.errors && form.controls.printedId.errors['foundNoPrintedIds']) {
              Der blev ikke fundet nogen brik ID'er
            }
            @if (
              form.controls.printedId.errors && (form.controls.printedId.errors['required'] || form.controls.printedId.errors['pattern'])
            ) {
              Brikkens ID består af et tal mellem 1 og 6 cifre
            }
          </mat-error>
          <mat-icon matSuffix></mat-icon>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field>
          <mat-label>RFID</mat-label>
          <input matInput placeholder="RFID" formControlName="idToken" value="" />
          <mat-error> Intet RFID - fremsøg og vælg en brik ID ovenfor for at få indsat et RFID </mat-error>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field class="mdc-textarea-fix">
          <mat-label>Adgangsgrupper</mat-label>
          <mat-select formControlName="selectedAccessGroups" multiple [compareWith]="compareObjects" okCustomDropDownArrowDirective>
            <mat-select-trigger>
              @let selectedAccessGroupsValue = getFirstAccessGroupName();
              {{ selectedAccessGroupsValue }}
              @if (form.controls.selectedAccessGroups.value.length > 1) {
                <span class="example-additional-selection">
                  (+{{ form.controls.selectedAccessGroups.value.length - 1 }}
                  {{ form.controls.selectedAccessGroups.value.length === 2 ? 'mere' : 'flere' }})
                </span>
              }
            </mat-select-trigger>
            @for (accessGroup of accessGroups; track accessGroup.identifier) {
              <mat-option [value]="accessGroup.identifier">{{ accessGroup.name }}</mat-option>
            }
          </mat-select>
          <mat-icon matSuffix></mat-icon>
        </mat-form-field>
      </div>
      @if (isFleetIdTag(idTagResult)) {
        <div class="form-row">
          <div>
            <adm-g4-agreement-number [control]="form.controls.agreementNumber" />
            <mat-hint class="tiny-text">
              Indtastet aftalenr bliver brugt til at fakturere alt forbrug for brikkerne tilknyttet brugeren
            </mat-hint>
          </div>
        </div>
      }
    </ng-container>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="unit-identifier">
    @if (idTagResult?.printedId) {
      <span>Brik ID:</span>
    }
    @if (!idTagResult?.printedId) {
      <span>Brik beskrivelse:</span>
    }
    {{ idTagResult?.printedId ? idTagResult?.printedId : idTagResult?.description }}
  </div>
  <div>
    <button mat-dialog-close type="button" mat-button>Annuller</button>
    <button
      class="actions__button"
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="saveDisabled()"
      [class.spinner]="saving()"
      [admRequiresFeatureRole]="roles['id-tag.enrich']"
      (click)="processIdTagAndClose()">
      Gem
    </button>
  </div>
</mat-dialog-actions>
